import React, { useEffect, useState } from 'react';
import { useAuth } from './AuthContext';

export default function AccessLogPage() {
  const { token } = useAuth();
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    fetch("/access-log", {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => {
        if (!res.ok) throw new Error("Erreur HTTP " + res.status);
        return res.json();
      })
      .then(setLogs)
      .catch(err => {
        console.error("Erreur chargement logs :", err);
      });
  }, [token]);

  return (
    <div className="container mt-5" style={{ paddingTop: '70px' }}>
      <h2 className="mb-4"> Historique des décisions d'accès</h2>
      {logs.length === 0 ? (
        <p className="text-muted">Aucun enregistrement pour le moment.</p>
      ) : (
        <div className="table-responsive">
          <table className="table align-middle shadow-sm border rounded">
            <thead className="table-light">
              <tr>
                <th className="px-3 py-2">Projet</th>
                <th className="px-3 py-2">Utilisateur</th>
                <th className="px-3 py-2">Décision</th>
                <th className="px-3 py-2">Motif</th>
                <th className="px-3 py-2">Décidé par</th>
                <th className="px-3 py-2">Date</th>
              </tr>
            </thead>
            <tbody>
              {logs.map(log => (
                <tr key={log.id} className="border-top">
                  <td className="px-3 py-2">#{log.project_id}</td>
                  <td className="px-3 py-2">{log.user_id}</td>
                  <td className="px-3 py-2">
                    {log.decision === 'approved' ? ' Approuvé' : ' Refusé'}
                  </td>
                  <td className="px-3 py-2">{log.reason || '—'}</td>
                  <td className="px-3 py-2">{log.decided_by}</td>
                  <td className="px-3 py-2">{new Date(log.created_at).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
